// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","711":"component---src-pages-mdx-slug-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"c8f1bab2cc49cc603461","711":"94dbb8f8641f4e580d08","883":"9b73a73ec07b6e42c367"}[chunkId] + ".js";
};